import { tokens } from '@ping/design-tokens';
import { ColorScheme } from './colorScheme';

export interface ColorSchemeTokens {
  surface: {
    primary: string;
    secondary: string;
    tertiary: string;
    app: string;
    panel: string;
    elevated: string;
    pressed: string;
  };
  text: {
    primary: string;
    secondary: string;
    tertiary: string;
    muted: string;
    disabled: string;
    onAccent: string;
  };
  action: {
    primary: string;
  };
  accent: {
    indigo: string;
    rose: string;
    mint: string;
    amber: string;
    violet: string;
    teal: string;
    pink: string;
    green: string;
    coral: string;
    slate: string;
    orchid: string;
    sky: string;
    brand: string;
    verified: string;
  };
  border: {
    primary: string;
    secondary: string;
    subtle: string;
    strong: string;
  };
  icon: {
    default: string;
    muted: string;
    onAccent: string;
  };
  presence: {
    online: string;
  };
  overlay: {
    scrim: string;
  };
}

export interface Colors {
  light: ColorSchemeTokens;
  dark: ColorSchemeTokens;
}

export const colors: Colors = {
  light: tokens.color.semantic.light,
  dark: tokens.color.semantic.dark,
};

export function getColors(scheme: ColorScheme): ColorSchemeTokens {
  return colors[scheme];
}
